module.exports = __webpack_public_path__ + "img/legacy_3.bae88e1b.jpg";